// extracted by mini-css-extract-plugin
export default {"addressBox":"address_addressBox__imEvs","addressItem":"address_addressItem__yRXz0","firstBox":"address_firstBox__y1y8x","lastBox":"address_lastBox__CTAhX"};